var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCoupon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.53 3.59a.75.75 0 0 0-1.06 0l-9.88 9.88a.75.75 0 0 0 0 1.06l1.069 1.068a2.75 2.75 0 0 1 3.742 3.742L9.47 20.41a.75.75 0 0 0 1.061 0l9.879-9.879a.75.75 0 0 0 0-1.06L19.34 8.4a2.75 2.75 0 0 1-3.742-3.742L14.53 3.59ZM12.41 2.53a2.25 2.25 0 0 1 3.182 0l1.171 1.172c.511.51.42 1.227.162 1.66a1.25 1.25 0 0 0 1.713 1.713c.433-.257 1.15-.349 1.66.162L21.47 8.41a2.25 2.25 0 0 1 0 3.182l-9.878 9.878a2.25 2.25 0 0 1-3.182 0l-1.172-1.171c-.51-.51-.42-1.228-.162-1.66a1.25 1.25 0 0 0-1.713-1.713c-.433.257-1.15.348-1.66-.163L2.53 15.591a2.25 2.25 0 0 1 0-3.182L12.41 2.53Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCoupon);
export default __webpack_public_path__ + "static/media/ic-coupon.a3774d7ebfe07d2131b49976ea297d35.svg";
export { ForwardRef as ReactComponent };